/*
Rajesh 09/26/2022 3031450488 report master changes
Sohel 10/26/2022  3031450488 changed table style
Prakash    26/10/2022 3031450488 Added classes for Table UI and TextFields.
Sai Maheshwar 10/30/2022 3031450488 disabled date format, print fields for text fields
Prakash 10/31/2022 3031450488  Removed styles for table UI and Added class.
Saikrishna 10/31/2022 3031450488 Fixed uncheck table row on delete of fields in report fields
Saikrishna 11/01/2022 3031450488 Added field length condition
Lalitha  11/11/2022  3031450488  Added Tooltip on DeleteIcon
Sai Maheshwar 11/12/2022 3031450488 fixed report fields check uncheck bug
Prakash 11/15/2022 3031450488 Added global styling class for text-alignment for table.
Sai Maheshwar 11/25/2022 3031450488 added reportFields components
Sohel 11/28/2022  3031450488 Report Field Added Date Format Field
Sai Maheshwar 12/01/2022  3031450488 fixed drag and drop issue
Saikrishna 4/12/2022 2700799562 Disabled delete option for work queues  default account number.
Akhila 12/07/2022 2700799562 rename text message of No record Found
Ashraf 01/20/2023 2700799562 changed total column name
Ravi 05/31/2023 2700799562 changed delete popup message
Sohel 06/03/2023 2700799562 Added Amount Format and Data Type Field
Sohel 06/03/2023 2700799562 Added Amount Format in Reports
Ravi 07/19/2023 2700799562 fixed field length disable issue
Ravi 07/21/2023 2700799562  enable print total based on amount and number fieldtype
Sohel 12/05/2023 2700799562 fix format field dropdown arrow issue 
*/
import React, { useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import { IconButton, Tooltip } from '@material-ui/core';

import { useSelector } from 'react-redux';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';

const FieldTable = ({
  recordFormatCode,
  selectedRows,
  setSelectedRows,
  values,
  handleChange,
  touched,
  errors,
  workQueue,
  handleDirty,
  setFieldValue,
  reportFieldsDeleteIdsRef,
  setSortFields,
  sortFields,
  sortFieldsDeleteIdsRef,
}) => {
  const [isDelete, setIsDelete] = useState(false);
  const deleteRef = useRef(null);

  const reorderItems = (startIndex, endIndex) => {
    const arr = [...selectedRows];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setSelectedRows(arr);
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };

  const handleDelete = (rowData, key) => {
    deleteRef.current = rowData;
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleConfirmDelete = () => {
    const arr = selectedRows.filter((r) => r.fieldName !== deleteRef.current.fieldName);
    if (deleteRef.current.workqueueFieldId) {
      const newArr = reportFieldsDeleteIdsRef.current.filter(
        (el) => el !== deleteRef.current.workqueueFieldId,
      );
      newArr.push(deleteRef.current.workqueueFieldId);
      reportFieldsDeleteIdsRef.current = newArr;
    }

    // removing from sorting fields
    const deleteSortField =
      (deleteRef.current?.fieldCode || deleteRef.current?.fieldName) +
      deleteRef.current.repositoryName;
    const arrSort = sortFields.filter(
      (r) => (r?.fieldCode || r?.fieldName) + r.repositoryName !== deleteSortField,
    );
    const deletedSortObj = sortFields.filter(
      (r) => r.fieldCode + r.repositoryName === deleteSortField,
    )?.[0];
    if (deletedSortObj?.workqueueSortFieldId) {
      sortFieldsDeleteIdsRef.current = [
        ...sortFieldsDeleteIdsRef.current,
        deletedSortObj?.workqueueSortFieldId,
      ];
    }
    setSortFields(arrSort);

    setSelectedRows(arr);
    handleDirty(true);
    handleCloseDialog();
  };
  const { dropDownData } = useSelector(({ addReportMaster }) => addReportMaster);
  const { roleData } = useSelector(({ role }) => role);
  const disableEdit = roleData?.window?.['Record Format']?.['RF']?.edit;

  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Seq',
    },
    {
      title: 'Repository',
    },
    {
      title: 'Field Header',
    },

    {
      title: 'Sort Seq',
    },
    {
      title: 'Sort Type',
    },
  ];
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Field"
        value={`Are you sure you want to delete the ${deleteRef.current?.fieldName} Field?`}
        handleSubmit={handleConfirmDelete}
      />
      <div
        className={
          'new-standard-textfields mui-custom-table-container custom-table  pt-0 global-field-table text-center-table'
        }
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <table>
            <thead className="recFormat-header-container">
              <tr>
                {columns.map(
                  ({ title, hidden = false }) =>
                    !hidden && (
                      <th key={title} className="recFormat-header">
                        {title}
                      </th>
                    ),
                )}
              </tr>
            </thead>
            <Droppable droppableId="droppabe-list">
              {(provided) => (
                <tbody ref={provided.innerRef} className="recFormat-body">
                  {selectedRows?.length > 0 ? (
                    selectedRows?.map((rowData, key) => {
                      return (
                        <Draggable key={key} draggableId={'draggable-' + key} index={key}>
                          {(provided) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <td className="recFormat-col recFormat-center">
                                <Tooltip title="Delete">
                                  <IconButton
                                    disabled={
                                      (recordFormatCode && !disableEdit) ||
                                      (workQueue
                                        ? rowData?.fieldName === 'ACCOUNT_NUMBER' &&
                                          rowData?.repositoryName === 'DB_ACCOUNT'
                                        : false)
                                    }
                                    onClick={(e) => {
                                      if (
                                        workQueue
                                          ? !(
                                            rowData?.fieldName === 'ACCOUNT_NUMBER' &&
                                              rowData?.repositoryName === 'DB_ACCOUNT'
                                          )
                                          : true
                                      ) {
                                        handleDelete(rowData, key);
                                      }
                                    }}
                                  >
                                    <DeleteOutlined />
                                  </IconButton>
                                </Tooltip>
                              </td>
                              <td className="recFormat-col global-field-textfields">{key + 1}</td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData.repositoryName}
                              </td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData.fieldHeader({
                                  values,
                                  handleChange,
                                  touched,
                                  errors,
                                  setFieldValue,
                                })}
                              </td>
                              <td className="recFormat-col field-2 global-field-textfields">
                                {rowData.sortSeqNum({
                                  values,
                                  touched,
                                  errors,
                                  setFieldValue,
                                  disabled: false,
                                })}
                              </td>
                              <td className="recFormat-col global-field-textfields field-2 report-table-textfields">
                                <div className="format-field report-table-field">
                                  {rowData.sortType({
                                    values,
                                    touched,
                                    errors,
                                    setFieldValue,
                                    disabled: false,
                                    dropDownData,
                                    rowData,
                                  })}
                                </div>
                              </td>
                            </tr>
                          )}
                        </Draggable>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.length}>
                        No records to display. To add fields to your report click the &quot;Map
                        Fields&quot; button in the top right of this section.
                      </td>
                    </tr>
                  )}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    </>
  );
};

export default FieldTable;
